










































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';

@Component({})
export default class RechargeModal extends Vue {
  private eventEmit = {
    eventCloseModal: 'eventCloseModal',
    eventAcceptModal: 'eventAcceptModal'
  };

  @Prop({default: '<div style="color: #111;">Số tiền trong ví của bạn không đủ để đặt cọc.</div><div class="text-danger">Hãy nạp tiền để tiếp tục đặt cọc!</div>'})
  private content!: string;

  @Prop({default: 0})
  private modalType!: number;

  private rechargeModel = {
    rechargeValue: 0,
    bankId: 0,
    tradeContent: ''
  };

  get rechargeMethods() {
    return DATA.rechargeMethods;
  }

  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }

  private async created() {
    document.documentElement.style.overflow = 'hidden';
  }

  private onClose() {
      document.documentElement.style.overflow = 'auto';
      this.$emit(this.eventEmit.eventCloseModal, {
        data: null,
        close: true
      });
  }

  private async onAccept() {
      const isValid = await (this.$refs['observer'] as any).validate();
      if (isValid) {
        document.documentElement.style.overflow = 'auto';
        this.$emit(this.eventEmit.eventAcceptModal, {
            data: this.rechargeModel,
            close: true
        });
      }
  }
}
